<div
    id="parentDiv"
    class="tabs-btns"
>
    <ng-container *ngFor="let tab of tabs.toArray()">
        <a
            (click)="[scrollTo(tab.id), selectTab(tab, currentSection === tab.id)]"
            class="tabs-item"
            [class.active-tab]="currentSection === tab.id"
        >
            <span [textContent]="tab.title"></span>
            <hr>
        </a>
    </ng-container>
    <div class="hr-style"></div>
</div>
<div
    navaarScrollSpy
    [spiedTags]="['NAVAAR-TAB-SCROLL-SPY']"
    (sectionChange)="onSectionChange($event)"
    class="tabs-content"
>
    <ng-content></ng-content>
</div>
